export const PRECISION = 5

export default function FormattedNumber(props: any) {
  let formatedNumber = parseFloat((props.number).toString()).toFixed(PRECISION)
  return (<span>{formatedNumber}</span>)
}
